import { MessageUtil } from '@/models/Message/MessageUtil';

export enum CsvImportResultDef {
    Success = 0,                // 成功
    GeneralFailure = 1,         // 失敗（汎用）
    EmptyFile = 2,              // ファイルが空
    MissingRequiredHeader = 3,  // 必須ヘッダがない
    DuplicateHeader = 4,        // ヘッダ重複
    NoData = 5,                 // データがない(ヘッダしかない)
    ContentIssue = 6,            // 内容に問題
    LimitOver = 7               // インポート数超過
}

export class ImportContentErrorInfo {
    // プロパティ
    property: string | null = null;
    // エラー内容
    errorDetail: string[] = [];
}

export class ImportErrorInfo {
    // csvファイル上の行数(1-index)
    line: number = -1;
    // エラー内容
    info: ImportContentErrorInfo[] = [];
}

export class ImportResult {
    // 開始時刻
    startTimeUTC: string | null = null;

    // 終了時刻
    endTimeUTC: string | null = null;

    /// 結果
    result: number = CsvImportResultDef.GeneralFailure;

    /// エラー内容
    errors: ImportErrorInfo[] | null = null;
}

export class ImportErrorDisplayInfo {
    strHTML: string = "";
    bit: number = MessageUtil.MB_ICON_WARNING;
}